import { useBasket } from '@components/BasketProvider'
import StoreNavigationProvider from '@components/StoreNavigationProvider'
import { useRedirectHereAfterLogin } from '@whitecobalt/tungsten/esm/common/hooks/useRedirectHereAfterLogin'
import ConditionalRoute from '@whitecobalt/tungsten/esm/components/ConditionalRoute'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Checkout, OrderConfirmation, OverlapBasket, ProductsHome, YourBasket, QuoteSubmitted, ProductList } from './Pages'

interface EcommerceProps {
    
}

const Ecommerce: React.FunctionComponent<EcommerceProps> = (props) => {
    useRedirectHereAfterLogin()

    const {states} = useBasket()
    return (
          <StoreNavigationProvider>
               <Switch>
                    <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         path="/store/checkout"
                         component={Checkout}
                         />        
                    <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         path="/store/order-confirmation/:orderID?"
                         component={OrderConfirmation}
                         />   
                    <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         path="/store/request-quote"
                         component={Checkout}
                         />    
                    <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         path="/store/quote-submitted/:quoteID?"
                         component={QuoteSubmitted}
                         />    
                    <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         path="/store/basket"
                         component={YourBasket}
                         />                                                                                
                    <ConditionalRoute
                         condition={states.hasOverlapBasket}
                         redirectTo="/store/basket"
                         path="/store/overlap-basket"
                         component={OverlapBasket}
                         exact
                         />
                    {/* <ConditionalRoute
                         condition={!states.hasOverlapBasket}
                         redirectTo="/store/overlap-basket"
                         exact
                         path="/store"
                         component={ProductsHome}
                         /> */}
                    <Route path="/store" exact render={() => { 
                         window.location.assign('https://halspan.com/store') 
                         return null
                    }}/> 
                    <Route path="/store" component={ProductList}/>
                    <Route path="*" render={() => { 
                         window.location.assign('https://halspan.com/404') 
                         return null
                    }}/>  
               </Switch>
          </StoreNavigationProvider>
    )
}

export default Ecommerce
